import React from 'react';
import { Crown } from '@phosphor-icons/react';
import { useFounders } from '@/lib/useFounders';

/**
 * FounderBadge — small flame icon shown when the subject holds a $35
 * Founders Pass. Accepts either a `user` object (with `founders_pass: true`)
 * or a `username` string (it will look up against the cached founders list).
 */
const FounderBadge = ({ user, username, size = 12, className = '' }) => {
  const { isFounder } = useFounders();
  const direct = user?.founders_pass;
  const byName = username ? isFounder(username) : false;
  if (!direct && !byName) return null;
  return (
    <span
      data-testid="founders-flame"
      title="Founders Pass holder"
      className={`inline-flex items-center gap-0.5 text-bx-gold founders-flame ${className}`}
    >
      <Crown size={size} weight="fill" />
    </span>
  );
};

export default FounderBadge;
